export function debounce(fn: Function, delay: number, immediate?: boolean) {
	let timer: any = null;
	return (...params: any[]) => {
		if (timer) {
			clearTimeout(timer);
		}
		if (immediate && !timer) {
			fn.call(null, ...params);
		} else {
			timer = setTimeout(() => {
				timer = null;
				fn.call(null, ...params);
			}, delay);
		}
	};
}

/** A utility function to delay foor a given time in milliseconds, returning a promise */
export const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));